import type { VkIdAutologinResponse } from '../../types/vkid';

const PAYLOAD_PARAM = 'payload';
const ERROR_CODE_PARAM = 'errorCode';

/** Получает payload VK ID из урла браузера */
export const getVkIdResponse = (): VkIdAutologinResponse => {
  const params = new URLSearchParams(window.location.search);
  const payload = params.get(PAYLOAD_PARAM);
  const errorCode = params.get(ERROR_CODE_PARAM);

  return {
    payload: payload ? JSON.parse(payload) : undefined,
    errorCode: errorCode ?? undefined,
  };
};
